import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useViewport } from '@/shared/lib'

import { useSidebarStore } from './sidebar'

export function useShell() {
  const sidebar = useSidebarStore()
  const route = useRoute()
  const { isMobile } = useViewport()

  // `immediate` fires with no previous value, so a desktop load keeps what the cookie
  // said and only a narrow one closes the sidebar.
  watch(
    isMobile,
    (mobile, wasMobile) => {
      if (mobile) sidebar.close(false)
      else if (wasMobile) sidebar.open(false)
    },
    { immediate: true }
  )

  watch(
    () => route.fullPath,
    () => {
      if (isMobile.value && sidebar.opened) sidebar.close()
    }
  )

  return { sidebar, isMobile }
}
